import { useState } from 'react'
import { Inbox, Plus } from 'lucide-react'
import { MailboxList } from '@components/mailboxes/MailboxList'
import { MailboxForm } from '@components/mailboxes/MailboxForm'
import { Mailbox } from '@/types'

export function MailboxesPage() {
  const [showForm, setShowForm] = useState(false)
  const [editingMailbox, setEditingMailbox] = useState<Mailbox | null>(null)

  const handleEdit = (mailbox: Mailbox) => {
    setEditingMailbox(mailbox)
    setShowForm(true)
  }

  const handleCloseForm = () => {
    setShowForm(false)
    setEditingMailbox(null)
  }

  const handleFormSuccess = () => {
    // Form will handle closing itself after success
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="icon-container icon-container-lg">
            <Inbox size={24} className="text-emerald-500" />
          </div>
          <h1 className="text-3xl font-bold text-slate-100">Mailboxes</h1>
        </div>
        <button
          onClick={() => {
            setEditingMailbox(null)
            setShowForm(true)
          }}
          className="btn-primary"
        >
          <Plus size={20} />
          Add Mailbox
        </button>
      </div>

      <MailboxList onEdit={handleEdit} />

      {showForm && (
        <MailboxForm
          mailbox={editingMailbox}
          onClose={handleCloseForm}
          onSuccess={handleFormSuccess}
        />
      )}
    </div>
  )
}
